import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  controlDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './bulk-delete-controls-dialog.controller';
import template from './bulk-delete-controls-dialog.html';
import bulkDeleteControlsConfirmDialog from '../dialog.bulkDeleteControlsConfirmDialog';


class dialogService {
  getOptions($event, { controlType, assessmentId }) {
    return {
      controller,
      controllerAs: 'bulkDeleteControlsDialogVM',
      locals: {
        controlType,
        assessmentId,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.admin.control.bulkDeleteControlsDialog', [
  ngCookies,
  controlDataService,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkDeleteControlsConfirmDialog,
])
  .service('bulkDeleteControlsDialog', dialogService)
  .name;
